import AsyncStorage from '@react-native-async-storage/async-storage';

const GAMES_PLAYED_KEY = 'gamesPlayedCount';
const PROMPT_EVERY_N_GAMES = 2;

export const premiumPromptUtils = {
  /**
   * Increments the count of completed single-player games and returns whether the user
   * should be prompted to upgrade to Premium (every Nth completed game).
   * Persisted locally so the count survives across sessions.
   */
  registerGamePlayedAndShouldPrompt: async (): Promise<boolean> => {
    try {
      const stored = await AsyncStorage.getItem(GAMES_PLAYED_KEY);
      const count = (stored ? parseInt(stored, 10) || 0 : 0) + 1;
      await AsyncStorage.setItem(GAMES_PLAYED_KEY, String(count));
      return count % PROMPT_EVERY_N_GAMES === 0;
    } catch (error) {
      console.error('Error tracking games played for premium prompt', error);
      return false;
    }
  },
};
